import 'aos/dist/aos.css';
import Aos from 'aos'
import React, { forwardRef, Ref, useEffect, useMemo } from 'react';
import { Dialog, Fab, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { EmblaCarousel, CreateCarousel, CreateCarouselArray, CarouselInput } from './EmblaCarousel';
import { EmblaOptionsType } from 'embla-carousel'
import './carousel.css'

//inputs predefinidos de clínicas
const CLINICAS_SLIDE_INPUT: CarouselInput[] = [
    {
        title: 'Centro Integral de Oncología',
        body: 'El cáncer es una enfermedad que afecta a hombres y mujeres en igual proporción. Contamos con un equipo experto de especialistas en el diagnóstico, tratamiento y seguimiento de una de las enfermedades que se ha convertido en la principal causa de muerte en Chile. La Unidad de Oncología Médica es la encargada del diagnóstico y tratamiento de las enfermedades neoplásicas no hematológicas (tumores sólidos) en pacientes con cáncer. Para ello, se hace una valoración y un manejo integral de estas patologías, ofreciendo un tratamiento sistémico, a fin de acompañar al paciente y su familia en todas las etapas de la enfermedad.',
        imgLink: 'Clinicas/01.png',
        imgAlt: 'Alemana',
        a: 'https://www.clinicaalemana.cl/especialidades/oncologia',
        aLink: 'https://www.indisa.cl/oncologia-y-hematologia'
    },
    {
        title: 'Oncología y Hematología',
        body: 'El cáncer es una enfermedad que afecta a hombres y mujeres en igual proporción. Contamos con un equipo experto de especialistas en el diagnóstico, tratamiento y seguimiento de una de las enfermedades que se ha convertido en la principal causa de muerte en Chile. La Unidad de Oncología Médica es la encargada del diagnóstico y tratamiento de las enfermedades neoplásicas no hematológicas (tumores sólidos) en pacientes con cáncer. Para ello, se hace una valoración y un manejo integral de estas patologías, ofreciendo un tratamiento sistémico, a fin de acompañar al paciente y su familia en todas las etapas de la enfermedad.',
        imgLink: 'Clinicas/02.png',
        imgAlt: 'Clínica Dávila',
        a: 'https://www.davila.cl/oncologia-medica/',
        aLink: 'https://www.davila.cl/oncologia-medica/'
    },

    {
        title: 'Oncología y Hematología',
        body: 'El Servicio de Hematología-Oncología de Clínica Santa María cuenta con un Centro Médico Oncológico ubicado en el 4to piso del Edificio Bellavista, además de una Unidad de Quimioterapia Ambulatoria ubicada en el mismo sitio y una Unidad de Quimioterapia Hospitalizada que cuenta con 5 camas para dichos procedimientos. La Hospitalización Oncológica se encuentra en el 3er piso del Edificio Santa María y en el 5to piso del Edificio Bellavista.',
        imgLink: 'Clinicas/03.png',
        imgAlt: 'Clínica Santa María',
        a: 'https://www.clinicasantamaria.cl/especialidades/oncologia',
        aLink: 'https://www.clinicasantamaria.cl/especialidades/oncologia'
    },

    {
        title: 'Encuentra la tranquilidad que necesitas',
        body: 'Nuestros oncólogos son médicos capacitados para atender tumores sólidos y todas las enfermedades hemato-oncológicas incluidas en el GES. Para ello, hemos desarrollado el Servicio de Oncología Ambulatoria, el cual cuenta con 12 boxes de atención y está orientado principalmente al tratamiento del cáncer mediante quimioterapia.',
        imgLink: 'Clinicas/04.png',
        imgAlt: 'Clínica Bupa Santiago',
        a: 'https://www.clinicabupasantiago.cl/unidades-y-servicios/centro-de-oncologia',
        aLink: 'https://www.clinicabupasantiago.cl/unidades-y-servicios/centro-de-oncologia'
    },

    {
        title: 'La importancia de la Prevención y de un Diagnóstico Precoz',
        body: 'La principal forma de disminuir el cáncer es a través de un diagnóstico a tiempo, lo que aumenta radicalmente las posibilidades de un resultado exitoso en el tratamiento y una mejor calidad de vida del paciente. Por otra parte, la Prevención puede ayudar a reducir el riesgo de adquirir algún tipo de cáncer, razón por la cual se torna muy importante mejorar los hábitos alimenticios, evitar el tabaco y cuidar la piel del sol, entre otras medidas.',
        imgLink: 'Clinicas/05.png',
        imgAlt: 'RedSalud Instituto del Cáncer',
        a: 'https://www.redsalud.cl/nuestra-red/instituto-del-cancer',
        aLink: 'https://www.redsalud.cl/nuestra-red/instituto-del-cancer'
    },

    {
        title: 'Cáncer UC',
        body: 'Nuestra misión es cuidar a los pacientes con cáncer y a sus familias, entregando una atención de calidad que aporte a su bienestar, respetando su dignidad e inspirada en principios cristianos, respaldados por un equipo de gran calidad humana, excelencia profesional y académica.',
        imgLink: 'Clinicas/06.png',
        imgAlt: 'Cáncer UC Christus',
        a: 'https://www.ucchristus.cl/especialidades-y-servicios/especialidades/cancer-uc',
        aLink: 'https://www.ucchristus.cl/especialidades-y-servicios/especialidades/cancer-uc'
    },

    {
        title: 'Por qué la mamografía es importante',
        body: 'La mamografía es un examen que permite detectar tempranamente el cáncer de mama, incluso antes de que existan síntomas. Realizarla de manera preventiva puede marcar la diferencia en la salud y en la vida de nuestras pacientes. Detecta el cáncer de mama incluso antes de que existan síntomas. Es el método más recomendado para la detección precoz del cáncer de mama. Permite encontrar lesiones en etapas iniciales, donde los tratamientos son más efectivos y menos invasivos. En Clínica Hospital del Profesor buscamos que cada paciente viva este proceso con acompañamiento humano, confianza y seguridad.',
        imgLink: 'Clinicas/07.png',
        imgAlt: 'Clínica Hospital del Profesor',
        a: 'https://www.chp.cl/agenda-mamografia/?source=banner',
        aLink: 'https://www.chp.cl/agenda-mamografia/?source=banner'
    },

    {
        title: 'Oncología y Hematología',
        body: 'El área multidisciplinaria de Oncología y Hematología de Clínica INDISA se creó para atender a los pacientes que padecen de cáncer, buscando lograr la curación de esta enfermedad y cuando eso no es posible otorgar todos los cuidados necesarios para prolongar su vida, manteniendo la mejor calidad de vida posible.',
        imgLink: 'Clinicas/08.png',
        imgAlt: 'Clínica INDISA',
        a: 'https://www.indisa.cl/oncologia-y-hematologia',
        aLink: 'https://www.indisa.cl/oncologia-y-hematologia'
    },

    {
        title: 'Oncología',
        body: 'La Oncología es una especialidad médica que se encarga del diagnóstico y tratamiento de los pacientes con cáncer a través de tres áreas principales: Oncología Médica, Radioterapia y Oncología Quirúrgica.',
        imgLink: 'Clinicas/09.png',
        imgAlt: 'Clínica MEDS',
        a: 'https://www.meds.cl/especialidades/oncologia/',
        aLink: 'https://www.meds.cl/especialidades/oncologia/'
    },

    {
        title: 'Unidad de Asesoramiento Genético Oncológico',
        body: 'Mediante un asesoramiento y test genético es posible determinar si una persona nació con una predisposición genética para desarrollar cáncer durante su vida, debido a una variante (mutación) en su ADN. En los pacientes con cáncer esta información es fundamental para ajustar el manejo y aplicar medidas preventivas futuras. Además, permite incorporar medidas de prevención más oportunas para los familiares en riesgo.',
        imgLink: 'Clinicas/10.png',
        imgAlt: 'FALP Asesoramiento Genético Oncológico',
        a: 'https://www.falp.org/fundacion/unidad-de-asesoramiento-genetico-oncologico-02/',
        aLink: 'https://www.falp.org/fundacion/unidad-de-asesoramiento-genetico-oncologico-02/'
    },

    {
        title: 'Centro de Cáncer',
        body: 'En la Clínica Universidad de los Andes, sabemos que enfrentar un diagnóstico o sospecha de cáncer puede generar incertidumbre. Por eso, en nuestro Centro de Cáncer te entregamos una atención integral desde el inicio, con tratamientos de vanguardia, tecnología de última generación y un equipo humano comprometido con tu bienestar. Aquí recibirás un acompañamiento cercano y personalizado en cada etapa del proceso: desde la primera consulta hasta el tratamiento y seguimiento. Nuestro equipo multidisciplinario evalúa cada caso de manera coordinada para ofrecerte el plan más adecuado, siempre enfocado en mejorar tu calidad de vida.',
        imgLink: 'Clinicas/11.png',
        imgAlt: 'Centro de Cáncer Clínica Universidad de los Andes',
        a: 'https://www.clinicauandes.cl/centros-y-programas/centro-de-cancer',
        aLink: 'https://www.clinicauandes.cl/centros-y-programas/centro-de-cancer'
    },

    {
        title: 'Centro del Cáncer CLC',
        body: 'En Clínica Las Condes contamos con un Centro del Cáncer integral, diseñado para acompañar a cada paciente y su familia en todas las etapas del proceso oncológico: prevención, detección precoz, diagnóstico, etapificación, tratamiento, rehabilitación y el seguimiento posterior. Nuestro equipo multidisciplinario de especialistas trabaja de manera coordinada para entregar una atención personalizada y humana, asegurando tanto el bienestar físico como emocional de quienes confían en nosotros, basado en las mejores prácticas recomendadas por la literatura científica actual.',
        imgLink: 'Clinicas/14.png',
        imgAlt: 'Centro del Cáncer Clínica Las Condes',
        a: 'https://www.clinicalascondes.cl/CENTROS-Y-ESPECIALIDADES/Centros/Centro-Clinico-del-Cancer',
        aLink: 'https://www.clinicalascondes.cl/CENTROS-Y-ESPECIALIDADES/Centros/Centro-Clinico-del-Cancer'
    },
]

// Función de clínicas
const Clinicas = forwardRef((props, ref: Ref<HTMLDivElement>) => {
    useEffect(() => { Aos.init({ duration: 500 }) }, []);

    const theme = useTheme();
    const isSmall = !useMediaQuery(theme.breakpoints.up('lg'))

    const [clinicaData, setClinicaData] = React.useState({
        open: false, data: {
            description: "",
            src: ''
        }
    });

    //Crear Slide para clínicas.
    const slide = useMemo(() => CreateCarouselArray(CLINICAS_SLIDE_INPUT, isSmall), [isSmall]);

    const OPTIONS: EmblaOptionsType = { loop: true, direction: 'rtl' }
    var videoDataArray = Array.from({ length: 15 }, (_, _1) => "")
    videoDataArray[9] = 'https://www.youtube.com/embed/7ouVSbw2XxE'
    videoDataArray[14] = 'https://www.youtube.com/embed/2R0MflMIWBs'

    return (<div className=' ItemSection ClinicaBackground' ref={ref}>
        <Typography variant='h4' data-aos='zoom-in'>
            Clínicas
        </Typography>
        <div data-aos="fade-up">
            <div style={{ display: "flex", flexDirection: isSmall ? "column" : "row", marginTop: "1rem" }} data-aos={'fade-right'}>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", minWidth: isSmall ? "60%" : "auto" }}>
                    {
                        slide.map((v, i) =>
                            <div onClick={() => { }}>
                                <Paper className='Partners'
                                    elevation={8} style={{ marginTop: (i % 2 === 0) ? "1rem" : "0" }} data-aos='fade-up' data-aos-delay={50 + 100 * i}>
                                    <div className='ClinicaThumbnail'
                                        onClick={() => { setClinicaData({ open: true, data: { description: '', src: videoDataArray[i] } }) }}>
                                        <img
                                            style={{ marginTop: (i % 2 === 0) ? "1rem" : "0", objectFit: 'contain', mixBlendMode: 'multiply' }}
                                            src={v.values.imgLink} width={isSmall ? 50 : 100} height={isSmall ? 50 : 100} alt="" /></div>
                                </Paper>
                            </div>
                        )
                    }
                </div>
                <div style={{ width: isSmall ? "100vw" : "40%", padding: "0rem" }}>
                    <EmblaCarousel options={OPTIONS} slides={slide}></EmblaCarousel>
                </div>
            </div>
        </div>
        <Dialog sx={{
            '& .MuiDialog-container': {
                '& .MuiPaper-root': {
                    width: '100%',
                },
            },
        }} open={clinicaData.open}>
            <div className='flex-column'>
                <div style={{ display: 'flex', width: "100%", justifyContent: "end", position: 'relative', paddingTop: '50%' }}>
                    <iframe title='Video' src={clinicaData.data.src} style={{ width: '100%', height: '100%', border: 'none', position: 'absolute', zIndex: '999', top: '0', left: '0' }}>

                    </iframe>
                    <div style={{ width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', display: 'flex', justifyContent: 'end' }}>
                        <Fab
                            onClick={() => {
                                setClinicaData({ open: false, data: clinicaData.data })
                            }}
                            color="secondary" size='small' style={{ margin: "0rem", position: 'fixed', transform: 'translate(calc(1rem + 10px), calc(-1rem - 10px))' }}>
                            <ClearIcon />
                        </Fab>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>);
});

export { Clinicas };